import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { SummaryDealExtendedTct } from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const getDeals = async (signal?: AbortSignal): Promise<SummaryDealExtendedTct[]> => {
	const response = await makeRequest<ApiV1.Response<SummaryDealExtendedTct[]>>(
		{ endpoint: API_PATHS.DEAL_GET, method: HTTP_METHOD.GET },
		{ abortSignal: signal }
	);
	return response.payload ?? [];
};
